var React = require('react');

function Bath (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M80,256H32V69.25a69.25,69.25,0,0,1,118.22-49l19.26,19.27c29.9-13.13,59.11-7.61,79.73,8.62l.17-.17A16,16,0,0,1,272,48l11.31,11.31a16,16,0,0,1,0,22.63L177.94,187.31a16,16,0,0,1-22.63,0L144,176a16,16,0,0,1,0-22.62l.17-.17c-16.23-20.62-21.75-49.85-8.62-79.73L116.28,54.22A21.26,21.26,0,0,0,80,69.25Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M32,384a95.4,95.4,0,0,0,32,71.09V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V480H384v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V455.09A95.4,95.4,0,0,0,480,384V336H32ZM496,256H16A16,16,0,0,0,0,272v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V272A16,16,0,0,0,496,256Z","className":"fa-primary","key":2})]);
}

Bath.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Bath;

Bath.default = Bath;
